import { ReactNode } from 'react';

export const PROJECT_CONTENT_TAB_TYPE = {
  TABLE_OF_CONTENT: 'TABLE_OF_CONTENT',
  CUSTOM: 'CUSTOM',
  STAT_LIST: 'STAT_LIST',
} as const;

export type ProjectContentTabName = keyof typeof PROJECT_CONTENT_TAB_TYPE;

export type ProjectContentTabType = (typeof PROJECT_CONTENT_TAB_TYPE)[ProjectContentTabName];

export interface ProjectContentTabBase {
  id: string;
  label: ReactNode;
  type: ProjectContentTabType;
  layout?: number;
}

export interface ProjectContentTableOfContentTab extends ProjectContentTabBase {
  type: typeof PROJECT_CONTENT_TAB_TYPE.TABLE_OF_CONTENT;
  content: {
    id: string;
    title: string;
    content?: ReactNode;
  }[];
}

export interface ProjectContentCustomTab extends ProjectContentTabBase {
  type: typeof PROJECT_CONTENT_TAB_TYPE.CUSTOM;
  content?: ReactNode;
}

export interface ProjectContentStatListItem {
  id: string;
  name: string;
  value: ReactNode;
  description?: ReactNode;
}

export interface ProjectContentStatListTab extends ProjectContentTabBase {
  type: typeof PROJECT_CONTENT_TAB_TYPE.STAT_LIST;
  content?: ProjectContentStatListItem[];
}

export type ProjectContentTab =
  | ProjectContentTableOfContentTab
  | ProjectContentCustomTab
  | ProjectContentStatListTab;

export interface ProjectContentData {
  id: string;
  tabs: ProjectContentTab[];
}

type SubListProps = {
  id: string;
  subItem: ReactNode;
};

export type ItemsProps = {
  id: string;
  item: ReactNode | Array<SubListProps>;
  content?: ReactNode | string;
};
